import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import showNotify from "Helpers/Notify";
import GetIdPop from "Helpers/GetIdPop";
import { Grid } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import { FlipOutlined } from "@material-ui/icons";
import DrawerService from "Services/http/endpoints/design/DrawerService";
import Translator from "Languages/Utility/Translator";
import { read, store } from "Helpers/LocalStorage";
import {
  getAddonsInfo,
  getPopList,
  getRebuildUnit,
  getUnitInfo,
  onSelectTools,
  resetAddons,
} from "Stores/actions";
import { push } from "Helpers/History";
import {
  DEACTIVE_SILENT_DRAWER,
  DESIGN_OPENONEUNIT,
  DESIGN_RESCALE,
  DRAWER_RESULT,
  GET_BACK_FROM_DESIGN,
  NEW_UNIT_INFO,
  SELECTED_UNIT_ID,
  UNIT_INFO,
  SHOW_UNIT_SIDE_DRAWER,
  DESIGNER_BREAK_FRAME,
  DESIGNER_BREAK_FRAME_ACTION,
} from "Stores/actionTypes";
import EditUnit from "./components/EditUnit";
import RightClickDialog from "./components/RightClickDialog/RightClickDialog";
import StatusHandler from "Helpers/StatusHandler";
import SelectTemplateDialog from "./components/SelectTemplateDialog";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import useScript from "Helpers/Hooks";
import { ReactSVG } from "react-svg";
import ArrowsIcon from "Assets/svg/icon/arrows.svg";
import EyeCloseIcon from "Assets/svg/icon/eye-close.svg";
import EyeIcon from "Assets/svg/icon/eye-open.svg";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import NewUnit from "Screens/Design/NewUnit/NewUnit";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import LoadOnConvertUnit from "./LoadOnConvertUnit";
import { useEffectEvent } from "react";
import SelectBreakFrame from "./components/SelectBreakFrame";

let templateCurrent = "";
let silentRebuildList = [];

export default function DesignMain({
  sizeFontDesigner,
  limitCouple,
  limitMulion,
  limitGuidLine,
  getUnitData,
  getOneUnit,
  setUnitData,
  totalSetting,
  parentLoading,
}) {
  const { t } = useTranslation();
  const status = useScript("/assets/DrawerHaxe.js");
  const dispatch = useDispatch();
  const {
    drawerResult,
    selectedTool,
    popList,
    unitInfo,
    checkAddon,
    addonsInfo,
    newUnitInfo,
    unitList,
    selectedProject,
    unitListPagination,
    selectedUnitId,
    selectedUnitINfo,
    selectedUnitImage,
    getBack,
    reScale,
    openUnit,
    silentDrawer,
    showUnitSideDrawer,
    breakFrame,
    breakFrameAction,
  } = useSelector((state) => ({
    drawerResult: state.design.drawerResult,
    selectedTool: state.design.selectedTool,
    popList: state.design.popList,
    unitInfo: state.design.unitInfo,
    checkAddon: state.design.checkAddon,
    addonsInfo: state.design.addonsInfo,
    newUnitInfo: state.design.newUnitInfo,
    unitList: state.design.unitList,
    selectedProject: state.project.selectedProject,
    unitListPagination: state.design.unitListPagination,
    selectedUnitId: state.design.selectedUnitId,
    selectedUnitINfo: state.design.selectedUnitINfo,
    getBack: state.design.getBack,
    reScale: state.design.reScale,
    openUnit: state.design.openUnit,
    silentDrawer: state.design.silentDrawer,
    showUnitSideDrawer: state.design.showUnitSideDrawer,
    breakFrame: state.design.breakFrame,
    breakFrameAction: state.design.breakFrameAction,
  }));
  const [drawer, SetDrawer] = useState(null);
  const [showEye, setShowEye] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [rightClickData, setRightClickData] = useState(null);
  const [openDialogRight, setOpenDialogRight] = useState(false);
  const [loading, setLoading] = useState(false);
  const [limeLoading, setLimeLoading] = useState(true);
  const [progress, setProgress] = useState(false);
  const [openNewUnit, setOpenNewUnit] = useState(false);
  const [openNewUnitAllow, setOpenNewUnitAllow] = useState(false);
  const [openUnitDrawer, setOpenUnitDrawer] = useState(false);
  const [closeDesign, setCloseDesign] = useState(false);
  const [record, setRecord] = useState(null);
  const [convertType, setConvertType] = useState(null);
  const [newUnitAction, setNewUnitAction] = useState(false);
  const [newUnitSettingData, setNewUnitSettingData] = useState({
    NameUnit: "",
    BreakH: 0,
    BreakW: 0,
  });
  const [openDialogSelectTemplate, setOpenDialogSelectTemplate] =
    useState(false);
  const [limeEmbed, setLimeEmbed] = useState(false);
  const [size, setSize] = useState(window.innerWidth);
  const [customeScale, setCustomScale] = useState(1);
  const [lastUnitId, setLastUnitId] = useState(-1);
  const [changeSave, setChangeSave] = useState(false);
  const [addNewOpen, setAddNewOpen] = useState(false);

  const [doSilentRebuild, setDoSilentRebuild] = useState(false);
  const [bugCurrentUnit, setBugCurrentUnit] = useState(false);
  const [doSilentRebuildIndex, setDoSilentRebuildIndex] = useState(0);
  const [silentRebuildLoading, setSilentRebuildLoading] = useState(false);

  window.addEventListener("resize", () => {
    setSize(window.innerWidth);
  });

  useEffect(() => {
    if (silentDrawer.active) {
      if (!doSilentRebuild) {
        setSilentRebuildLoading(true);
        if (doSilentRebuildIndex < silentDrawer.list.length) {
          if (doSilentRebuildIndex === 0) {
            drawer.clear_everything();
            silentRebuildList = silentDrawer.list.map((items) => {
              return { id: items.Id, name: items.Name, type: "NO" };
            });
          }
          const unitId = window.location.pathname.split("/design/unit/");
          const reloadId = silentDrawer.list[doSilentRebuildIndex].Id;
          if (unitId.length > 1 && +unitId[1] === reloadId) {
            setBugCurrentUnit(true);
            setDoSilentRebuild(true);
          } else {
            changeSilentRebuildList(reloadId, "PEN");
            dispatch({ type: DESIGN_OPENONEUNIT, id: reloadId });
            setDoSilentRebuild(true);
          }
        } else {
          dispatch({ type: DESIGN_OPENONEUNIT, id: silentDrawer.list[0].Id });
          dispatch({ type: DEACTIVE_SILENT_DRAWER });
          setSilentRebuildLoading(false);
          getUnitData(1);
        }
      }
    } else {
      setDoSilentRebuild(false);
      setDoSilentRebuildIndex(0);
    }
  }, [silentDrawer, doSilentRebuild]);

  const changeSilentRebuildList = (id, type) => {
    silentRebuildList = silentRebuildList.map((items) => {
      if (items.id === id) return { ...items, type };
      else return items;
    });
  };

  const nextOnSilentDrawer = (id) => {
    if (silentDrawer && silentDrawer.active) {
      setTimeout(() => {
        changeSilentRebuildList(id, "OK");
        setDoSilentRebuildIndex(doSilentRebuildIndex + 1);
        setDoSilentRebuild(false);
      }, 500);
    }
  };

  useEffect(() => {
    if (bugCurrentUnit) {
      setDoSilentRebuildIndex(doSilentRebuildIndex + 1);
      setDoSilentRebuild(false);
      setBugCurrentUnit(false);
    }
  }, [bugCurrentUnit]);

  useEffect(() => {
    dispatch({ type: DEACTIVE_SILENT_DRAWER });
    setNewUnitSettingData({
      NameUnit: totalSetting.NameUnit,
      BreakH: totalSetting.BreakH,
      BreakW: totalSetting.BreakW,
    });
  }, []);

  useEffect(() => {
    if (changeSave) {
      setChangeSave(false);
      if (lastUnitId !== -1) onChangeUnitList(lastUnitId);
    }
  }, [changeSave]);

  const backToSave = async (unitId, designString, URL) => {
    setLoading(true);
    dispatch(onSelectTools({}));
    dispatch({
      type: SELECTED_UNIT_ID,
      selectedUnitImage: null,
    });
    try {
      if (designString.length > 1) {
        const id = unitId;
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdUnit: id,
        };
        setRecord(designString);
        const response = await dispatch(getUnitInfo(params));
        dispatch({
          type: DRAWER_RESULT,
          drawerResult: { IdUnit: +id, T: response },
        });
        // dispatch({
        //   type: DRAWER_RESULT,
        //   drawerResult: { ...drawerResult, T: response, IdUnit: +id },
        // });
        const paramsPop = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdBrandFitting: response["Id_brand_fitting"],
        };
        await dispatch(getPopList(paramsPop));
        setNewUnitAction(false);
      }
    } catch (err) {
      console.error("[backToSave - DesignMain]", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    (async () => {
      if (window.location.pathname.includes("/design/unit")) {
        setLoading(true);
        dispatch(onSelectTools({}));
        try {
          if (!newUnitAction) {
            const unitId = window.location.pathname.split("/design/unit/");
            if (unitId.length > 1) {
              const id = unitId[1];
              const params = {
                KeyGroup: read("groupKey"),
                KeyUser: read("userKey"),
                IdUnit: id,
              };
              setRecord(null);
              var response = await dispatch(getRebuildUnit(params));
              var Template = JSON.parse(response.T);
              // const _response = await dispatch(getUnitInfo(params));
              const paramsPop = {
                KeyGroup: read("groupKey"),
                KeyUser: read("userKey"),
                IdBrandFitting: Template[0]["Id_brand_fitting"],
              };
              await dispatch(getPopList(paramsPop));
              // dispatch({
              //   type: SELECTED_UNIT_ID,
              //   selectedUnitId: id,
              // });
              dispatch({
                type: DRAWER_RESULT,
                drawerResult: { IdUnit: +id, T: response.T },
              });
              store("unitId", id);
              const _unitInfo = unitList.find((i) => i.Id === +id);
              if (_unitInfo) {
                dispatch({
                  type: SELECTED_UNIT_ID,
                  selectedUnitId: +id,
                  selectedUnitINfo: {
                    Id: _unitInfo.Id,
                    CountUnit: _unitInfo.CountUnit,
                    HUnit: _unitInfo.Hunit,
                    Image: _unitInfo.Image,
                    Location: _unitInfo.Location,
                    Name: _unitInfo.Name,
                  },
                });
              }
            }
          }
          setLoading(false);
        } catch (err) {
          console.error("[useEffect - DesignMain]", err);
          setLoading(false);
        }
      }
    })();
  }, [window.location.pathname]);

  const unChecked = async () => {
    const params = {
      keyGroup: read("groupKey"),
      keyUser: read("userKey"),
      idProject: selectedProject.Id,
      idUnit: 0,
      checked: false,
    };
    await DrawerService.selectUnitInDrawer(params);
  };

  window.Get_IsSave = async (arg) => {
    if (selectedUnitId) {
      try {
        if (arg === "true") {
          setProgress(true);
          await onFitScreen();
          drawer.saveWeb("false");
        }
      } catch {
        setProgress(false);
      }
    } else {
      setProgress(false);
    }
  };

  const onSave = async () => {
    await onFitScreen();
    drawer.IsSave();
  };

  const onClickUnitList = () => {
    drawer.IsSave();
    setOpenUnitDrawer(true);
  };

  const addNewUnit = () => {
    drawer.IsSave();
    setOpenNewUnit(true);
    setAddNewOpen(false);
  };

  useEffect(() => {
    (async () => {
      if (getBack.mode === 1) {
        await unChecked();
        drawer.IsSave();
        setCloseDesign(true);
      }
    })();
  }, [getBack]);

  useEffect(() => {
    if (!progress) {
      if (openUnitDrawer) {
        setOpenUnitDrawer(false);
        push(`/design/unit/${openUnit}`);
        dispatch({ type: DESIGN_OPENONEUNIT, id: 0 });
      } else if (openNewUnit) {
        setOpenNewUnit(false);
        setNewUnitAction(true);
        setOpenNewUnitAllow(true);
      } else if (closeDesign) {
        setCloseDesign(false);
        dispatch({ type: GET_BACK_FROM_DESIGN, mode: 2, address: getBack.URL });
      }
    }
  }, [openUnitDrawer, openNewUnit, closeDesign, progress]);

  const handleZoomIn = (e) => {
    e.preventDefault();
    setCustomScale(customeScale + 0.1);
  };

  const handleZoomOut = (e) => {
    e.preventDefault();
    setCustomScale(customeScale - 0.1);
  };

  const handleZoomReset = (e) => {
    e.preventDefault();
    setCustomScale(1);
  };

  const onClickEye = () => {
    if (drawer) {
      setShowEye(!showEye);
      drawer.show_environment_guideline(!showEye);
    }
  };

  const onEqualGlass = () => {
    if (drawer) {
      onFitScreen();
      drawer.set_equels_glass();
      drawer.roundNode();
    }
  };

  // useEffect(() => {
  //   window.addEventListener("keydown", (event)=>{
  //     console.log('selected key:',event);
  //   })
  // },[])

  const onFitScreen = async () => {
    try {
      if (drawer) {
        const openfl = document.getElementById("openfl-content");
        openfl.style.imageRendering = "optimize-contrast";
        openfl.style["-ms-interpolation-mode"] = "nearest-neighbor";
        //! <div style="image-rendering: optimize-contrast;-ms-interpolation-mode: nearest-neighbor;" id="openfl-content"></div>
        const designMainWidth = openfl.offsetWidth;
        const designMainHeight = openfl.offsetHeight - 70;
        await drawer.c_scale("0", "0");
        try {
          let convas = openfl.childNodes[0];
          // convas.width = (openfl.offsetWidth * 95)/100;
          // convas.height = (openfl.offsetHeight * 95)/100;
          convas.style.width = "100%";
          convas.style.height = "auto";
          convas.style.transition = "all 0.3s ease-in-out";
          convas.style.position = "absolute";
          convas.style.top = 0;
          convas.style.left = 0;
        } catch (err) {
          console.error("[catch error]", err);
        }
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };

  useEffect(() => {
    onFitScreen();
  }, [customeScale]);

  useEffect(() => {
    if (reScale) {
      if (
        window.location.pathname.split("/design/unit/").length > 1 &&
        window.location.pathname.split("/design/unit/")[1] !== ""
      ) {
        setLoading(true);
        setTimeout(() => {
          onFitScreen();
          setLoading(false);
        }, 500);
      }
      dispatch({ type: DESIGN_RESCALE, tun: false });
    }
  }, [reScale]);

  const sendSaveData = async (
    arg,
    ImageDesigner,
    imageWhite,
    ImageGuideLine,
    ImageGuideLineWhite
  ) => {
    setLoading(true);
    const data = JSON.parse(arg);
    var locationPic = data["minPicXY"];
    let OnlyImage = null;
    if (silentDrawer && silentDrawer.active) {
      silentDrawer.list.map((item) => {
        if (item.Id === drawerResult.IdUnit) {
          if (item.Type === "Image") {
            OnlyImage = { OnlyImage: true };
          }
        }
      });
    }
    const result = {
      IdUnit: drawerResult.IdUnit,
      ...OnlyImage,
      KeyGroup: read("groupKey"),
      KeyUser: read("userKey"),
      ImageDesigner,
      ImageGuideLine,
      Scale: +data.scale,
      Wunit: +data.width,
      Hunit: +data.height,
      T: templateCurrent, //NewUnit(initTemplate)   | Rebuild //Tarkibi
      B: data["reBuild_base_array"],
      C: data["reBuild_couple_array"],
      N: data["reBuild_node_array"],
      M: data["reBuild_master_base_array_json"],
      U: data["reBuild_utlity_array"],
      Frame: JSON.parse(data.frame),
      Mulion: JSON.parse(data.mulion),
      OverHung: JSON.parse(data["overhang"]),
      Sash: JSON.parse(data["sash"]),
      MulionRail: JSON.parse(data["molionRail"]),
      MulionFrameRail: JSON.parse(data["molionFrame"]),
      SashBar: JSON.parse(data["sashBar"]),
      ConectorSash: JSON.parse(data["conector_sash"]),
      InterLock: JSON.parse(data["interlock"]),
      Couple: JSON.parse(data["couple"]),
      ZehvarBarn: JSON.parse(data["zehvar_baran"]),
      ShapeGlass: JSON.parse(data["glass"]),
      ShapeGlassDetail: JSON.parse(data["glassDetail"]),
      ShapePanel: JSON.parse(data["panel"]),
      ShapePanelDetail: JSON.parse(data["panelDetail"]),
      ShapeNet: JSON.parse(data["net"]),
      ShapeNetDetail: JSON.parse(data["netDetail"]),
      ShapeFitting: JSON.parse(data["pop"]),
      ShapeFittingDetail: JSON.parse(data["popDetail"]),
      Rokob: JSON.parse(data["rocoob"]),
      Consumable: JSON.parse(data["consumble"]),
      PicX: +locationPic.substr(0, locationPic.indexOf(",")),
      PicY: +locationPic.substr(locationPic.indexOf(",") + 1),
      PayehRailFix: JSON.parse(data["payehRailFix"]),
      Rail: JSON.parse(data["rail"]),
      CoverFrame: JSON.parse(data["coverFrame"]),
      AdaptorPivot: JSON.parse(data["adaptorPivot"]),
      IntoFrame: JSON.parse(data["intoFrame"]),
      InterLockBetween: JSON.parse(data["interlockBetween"]),
      ZehvarBackKatibeh: JSON.parse(data["zehvar_back_katibeh"]),
    };
    try {
      const response = await DrawerService.postDesignedUnitData(result);
      let err = StatusHandler(response);
      if (!err.isFail) {
        setLastUnitId(response.data.Value);
        showNotify({ text: t("SaveUnitSuccessfully"), customClass: "success" });
        if (silentDrawer && !silentDrawer.active) setChangeSave(true);
        setLoading(false);
        setProgress(false);
        nextOnSilentDrawer(drawerResult.IdUnit);
        await dispatch(resetAddons());
      }
      setProgress(false);
    } catch (e) {
      setLoading(false);
      setProgress(false);
    }
  };

  const onChangeUnitList = async (newUnitId) => {
    let exist = [false, -1, -1];
    await unitList.map((u, index) => {
      if (u.Id === newUnitId) {
        exist = [true, index, u.Id];
      }
    });
    if (exist[0]) {
      const preList = unitList;
      let ba = preList.slice(0, exist[1]);
      let aa = preList.slice(exist[1] + 1);
      const _response = await getOneUnit(newUnitId);
      let na = ba.concat(_response.Value).concat(aa);
      setUnitData(na, unitListPagination);
    } else {
      if (unitListPagination.Total === unitList.length) {
        const _response = await getOneUnit(newUnitId);
        const newList = unitList.concat(_response.Value);
        setUnitData(newList, {
          ...unitListPagination,
          Total: unitListPagination.Total + 1,
        });
      } else {
        setUnitData(unitList, {
          ...unitListPagination,
          Total: unitListPagination.Total + 1,
        });
      }
    }
  };

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  };

  const handleDialogRightClick = () => setOpenDialogRight(!openDialogRight);

  const handleDialogSelectTemplate = () =>
    setOpenDialogSelectTemplate(!openDialogSelectTemplate);

  const sendRightClickData = (values) => {
    if (drawer) {
      const strJson = "[" + JSON.stringify(values) + "]";
      drawer.changeProperty(strJson);
    }
  };

  const sendConvertData = (newData, newTemplate) => {
    if (drawer) {
      const strJson = "[" + JSON.stringify(newTemplate) + "]";
      if (newTemplate) {
        templateCurrent = "[" + JSON.stringify(newTemplate) + "]";
      }
      drawer.convert_Property(strJson);

      setOpenDialogSelectTemplate(false);
      showNotify({
        text: t("mission_accomplished"),
        customClass: "success",
      });

      setConvertType(null);
    }
  };

  const onConvertType = (type) => {
    if (type === "sliding") {
      if (unitInfo.Id_template_bazsho === 0) {
        handleDialogSelectTemplate();
      } else {
        const convertData = {
          Group_base: convertType.group_base,
          Id_template_bazsho: unitInfo.Id_template_bazsho,
          Id_frame_bazsho: unitInfo.Id_frame_bazsho,
          Id_mulion_bazsho: unitInfo.Id_mulion_bazsho,
          Id_sash_bazsho: unitInfo.Id_sash_bazsho,
          Id_sash_door_bazsho: unitInfo.Id_sash_door_bazsho,
          Id_averhang_bazsho: unitInfo.Id_averhang_bazsho,
          Id_zehvar_bazsho: unitInfo.Id_zehvar_bazsho,
          Id_brand_bazsho: unitInfo.Id_brand_bazsho,
          Size_frame_bazsho: unitInfo.Size_frame_bazsho,
          Size_sash_bazsho: unitInfo.Size_sash_bazsho,
          Size_sash_door_bazsho: unitInfo.Size_sash_door_bazsho,
          Size_mulion_bazsho: unitInfo.Size_mulion_bazsho,
        };
        sendConvertData(convertData);
      }
    }
    if (type === "pop") {
      if (convertType.popCount > 1) {
        const convertData = {
          Id_frame_bazsho: unitInfo.Id_frame,
          Id_mulion_bazsho: 0,
          Id_sash_bazsho: 0,
          Id_sash_door_bazsho: 0,
          Id_averhang_bazsho: 0,
          Id_zehvar_bazsho: unitInfo.Id_zehvar2,
          Id_brand_bazsho: 0,
          Size_mulion_bazsho: 0,
          Size_frame_bazsho: unitInfo.Size_frame,
          Size_sash_bazsho: 0,
          Size_sash_door_bazsho: 0,
          Group_base: convertType.group_base,
          Id_template_bazsho: 0,
        };
        sendConvertData(convertData);
      } else if (convertType.popCount === 1) {
        const convertData = {
          Id_frame_bazsho: 0,
          Id_mulion_bazsho: 0,
          Id_sash_bazsho: 0,
          Id_sash_door_bazsho: 0,
          Id_averhang_bazsho: 0,
          Id_zehvar_bazsho: 0,
          Id_brand_bazsho: 0,
          Size_mulion_bazsho: 0,
          Size_frame_bazsho: 0,
          Size_sash_bazsho: 0,
          Size_sash_door_bazsho: 0,
          Group_base: convertType.group_base,
          Id_template_bazsho: 0,
        };
        const updateUnitInfo = {
          ...unitInfo,
          ...convertData,
        };
        dispatch({
          type: UNIT_INFO,
          unitInfo: updateUnitInfo,
        });
        sendConvertData(convertData);
      }
    }
  };

  useEffect(() => {
    if (openUnit) {
      if (openUnit === -1) {
        dispatch({ type: DESIGN_OPENONEUNIT, id: 0 });
        drawer.clear_everything();
      } else {
        onClickUnitList();
      }
    }
  }, [openUnit]);

  useEffect(() => {
    if (status === "ready") {
      const SetLimeDrawer = () => {
        if (!limeEmbed) {
          setLimeEmbed(true);
          const data = window.lime.embed("DrawerHaxe", "openfl-content", 0, 0, {
            parameters: {},
          });
          SetDrawer(data);
        }
      };
      setTimeout(SetLimeDrawer, 0);
    }
  }, [status]);

  useEffect(() => {
    if (breakFrameAction) {
      drawer.SetBreakFrame(breakFrameAction);
      dispatch({
        type: DESIGNER_BREAK_FRAME_ACTION,
        data: null,
      });
      dispatch({
        type: DESIGNER_BREAK_FRAME,
        data: null,
      });
    }
  }, [breakFrameAction]);

  window.Change_Break_Frame = (arg) => {
    dispatch({
      type: DESIGNER_BREAK_FRAME,
      data: arg,
    });
  };
  //* --------------------
  // window.KeyBoardShow = (arg) => {
  //   console.log("KeyBoard:" + arg);
  // };
  // useEffect(() => {
  //* --------------------
  window.completedDrawer = () => {
    setLimeLoading(false);
  };
  //* --------------------
  window.DesignMessage = (arg) => {
    showNotify({ text: t(arg), customClass: "warning" });
  };
  //* --------------------
  window.GetSaveWeb = async (arg, image, imageWhite, imageG, imageGWhite) => {
    await sendSaveData(arg, image, imageWhite, imageG, imageGWhite);
    dispatch({ type: SELECTED_UNIT_ID, selectedUnitImage: image });
  };
  //* --------------------
  window.get_size_glass = async (arg) => {
    try {
      const str = arg.replace("[", "").replace("]", "");
      var params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        ...JSON.parse(str),
      };
      const response = await DrawerService.getEqualGlass(params);
      const sizeEqual = "[" + JSON.stringify(response.data.Value) + "]";
      drawer.set_size_glass(sizeEqual);
      drawer.roundNode();
      showNotify({
        text: t("successfullyEqualGlassOperation"),
        customClass: "success",
      });
    } catch (err) {
      console.error("equal:", err);
    }
  };
  //* --------------------
  window.state_ts = async (arg) => {
    const parts = arg.split(",");
    const state = parts[0];
    const bottom = parts[1].split("+")[0];
    const top = parts[1].split("+")[1];
    const info = {
      ...addonsInfo,
      threshold: {
        state,
        top,
        bottom,
      },
    };
    await dispatch(getAddonsInfo(info));
  };
  //* --------------------
  window.state_pakhor = async (arg) => {
    const parts = arg.split(",");
    const state = parts[0];
    const bottom = parts[1].split("+")[0];
    const info = {
      ...addonsInfo,
      bottom_jamb: {
        state,
        bottom,
      },
    };
    await dispatch(getAddonsInfo(info));
  };
  //* --------------------
  window.state_altitude = async (arg) => {
    const parts = arg.split(",");
    const state = parts[0];
    const top = parts[1].split("+")[0];
    const bottom = parts[1].split("+")[1];
    const info = {
      ...addonsInfo,
      lifting_profile: {
        state,
        top,
        bottom,
      },
    };
    await dispatch(getAddonsInfo(info));
  };
  //* --------------------
  window.RIGHT_CLICK = (arg) => {
    let str = arg.substr(1, arg.length - 2);
    const data = JSON.parse(str);
    setRightClickData(data);
  };
  //* --------------------
  window.get_labeh_frame = async (arg) => {
    try {
      const params = {
        KeyGroup: read("groupKey"),
        keyUser: read("userKey"),
        Id: arg,
      };
      const response = await DrawerService.getEdgeProfileDesign(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const value = response.data.Value;
        drawer.set_size_labeh_frame(value);
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
  //* --------------------
  window.get_wintech_id = async (arg) => {
    // console.log("get_wintech_id", arg);
    const s1 = arg.split(",");
    const s2 = s1[1].split("+");
    const id = s2[0];
    const index = s2[1];
    try {
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: id,
      };
      const response = await DrawerService.getSpecialGroup(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const value = response.data.Value;
        // drawer.set_molion_interlock(value, index);
        drawer.set_wintech_id(value, index);
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
  //* --------------------
  window.get_size_profill = async (arg) => {
    try {
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: arg,
      };
      const response = await DrawerService.getSizeProfileDrawer(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const value = response.data.Value;
        drawer.set_size_profill(value);
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
  //* --------------------
  window.get_size_panel = async (arg) => {
    const string1 = arg.replace("[", "").replace("]", "");
    let panel_size = JSON.parse(string1);
    try {
      if (panel_size.is_rail) {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          s1: panel_size.s1,
          s2: panel_size.s2,
          e2: panel_size.e2,
          e1: panel_size.e1,
          ang1: panel_size.ang1,
          ang2: panel_size.ang2,
          panel_id: panel_size.panel_id,
        };
        const response = await DrawerService.getRailPanelData(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          panel_size.s1 = response.data.Value.SizeCalc;
          panel_size.panel_id = response.data.Value.SizePanel;
          const jPanelSize = "[" + JSON.stringify(panel_size) + "]";
          drawer.panel_sort_size(jPanelSize);
          showNotify({
            text: t("successfullyPanelCompletion"),
            customClass: "success",
          });
        }
      } else {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          ...panel_size,
        };
        const response = await DrawerService.getPopPanelData(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const jPanelSize = "[" + JSON.stringify(response.data.Value) + "]";
          drawer.panel_sort_size(jPanelSize);
          showNotify({
            text: t("successfullyPanelCompletion"),
            customClass: "success",
          });
        }
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
  //* --------------------
  window.Convert_Frame_style = (arg) => {
    let data = JSON.parse(arg);
    // console.log("Convert_Frame_style", data);
    if (data[0].is_error) {
      setConvertType(null);
      return;
    }
    const slidingCount = data.filter((item) => item.rail).length;
    const popCount = data.filter((item) => !item.rail).length;
    const clicked = data.filter((item) => item.is_change)[0];
    clicked.slidingCount = slidingCount;
    clicked.popCount = popCount;
    setConvertType(clicked);
  };
  //   SetDoFuncs(true);
  // }, []);

  useEffect(() => {
    if (rightClickData) {
      if (
        rightClickData.Id_frame === 0 &&
        rightClickData.Id_sash === 0 &&
        rightClickData.Id_panel === 0 &&
        rightClickData.Id_glazing === 0 &&
        rightClickData.Id_couple === 0 &&
        rightClickData.Id_mulion === 0 &&
        rightClickData.Id_net === 0 &&
        rightClickData.Id_glass === 0 &&
        rightClickData.Id_brand_fitting === 0 &&
        rightClickData.Id_type_pop_fitting === 0
      ) {
        setOpenDialogRight(false);
      } else {
        setOpenDialogRight(!openDialogRight);
      }
    }
  }, [rightClickData]);

  useEffect(() => {
    setConvertType(null);
    if (
      drawer &&
      selectedTool &&
      (selectedTool.type === "general" ||
        selectedTool.type === "division" ||
        selectedTool.type === "other" ||
        selectedTool.type === "drawer")
    ) {
      drawer.setClickModel(selectedTool.key);
    }
    if (
      drawer &&
      selectedTool &&
      (selectedTool.type === "window" || selectedTool.type === "door")
    ) {
      const id1 = GetIdPop(
        popList,
        unitInfo["Type_struct"],
        selectedTool.type,
        selectedTool.name
      );
      const id2 = selectedTool.name2
        ? GetIdPop(
            popList,
            unitInfo["Type_struct"],
            selectedTool.type,
            selectedTool.name2
          )
        : null;
      drawer.setPopModel(selectedTool.key, id1, id2);
      //! agar id1 === 0 ? warning ->  این بازشو برای این برند یراق تعریف نشده است
    }

    if (drawer && selectedTool.type === "flashing") {
      drawer.rocoob(selectedTool.Id, selectedTool.Size);
    }
    if (drawer && selectedTool.type === "threshold") {
      drawer.ts(
        selectedTool.Id,
        selectedTool.Size,
        selectedTool.state,
        +selectedTool.bottom,
        +selectedTool.top
      );
    }
    if (drawer && selectedTool.type === "lifting_profile") {
      drawer.set_altitude(
        selectedTool.Id,
        selectedTool.Size,
        selectedTool.state
      );
    }
    if (drawer && selectedTool.type === "bottom_jamb") {
      drawer.pakhor(selectedTool.Id, selectedTool.Size, selectedTool.bottom, 1);
    }
    if (drawer && selectedTool.type === "foldSlide") {
      drawer.setClickModel("Akardeoni");
      drawer.setAcardeModelMobile(JSON.stringify(selectedTool.data));
    }
  }, [selectedTool]);

  useEffect(() => {
    if (drawer) {
      if (checkAddon === "threshold") {
        drawer.state_of_ts();
      }
      if (checkAddon === "lifting_profile") {
        drawer.state_of_altitude();
      }
      if (checkAddon === "bottom_jamb") {
        drawer.state_of_pakhor();
      }
    }
  }, [drawer, checkAddon]);

  useEffect(() => {
    doRebuild();
  }, [drawerResult]);

  const doRebuild = async () => {
    if (drawerResult) {
      if (drawer && !record) {
        try {
          try {
            await drawer.clear_everything();
          } catch (err) {
            console.error("clear_everything", err);
          }
          templateCurrent = drawerResult.T;
          await drawer.rebuild(
            drawerResult.B,
            drawerResult.C,
            drawerResult.N,
            drawerResult.T,
            drawerResult.M,
            drawerResult.U,
            document.getElementById("openfl-content").offsetWidth,
            document.getElementById("openfl-content").offsetHeight - 30,
            sizeFontDesigner,
            limitCouple,
            limitMulion,
            limitGuidLine
          );
          dispatch({
            type: DESIGNER_BREAK_FRAME_ACTION,
            data: null,
          });
          dispatch({
            type: DESIGNER_BREAK_FRAME,
            data: null,
          });
          await onFitScreen();
          if (silentDrawer && silentDrawer.active && doSilentRebuild) {
            setTimeout(() => {
              drawer.IsSave();
            }, 500);
          }
        } catch (err) {
          console.error("doRebuild [E1]", err);
        }
      } else if (drawer && record && newUnitInfo) {
        try {
          templateCurrent = JSON.stringify(drawerResult.T);
          drawer.initTemplate("[" + templateCurrent + "]");
          drawer.drawShape(
            newUnitInfo,
            sizeFontDesigner,
            limitCouple,
            limitMulion,
            limitGuidLine
          );
          await onFitScreen();
          drawer.saveWeb("false");
          push(`/design/unit/${drawerResult.IdUnit}`);
          dispatch({ type: NEW_UNIT_INFO, newUnitInfo: null });
        } catch (err) {
          console.error("doRebuild [E2]", err);
        }
      }
    }
  };

  const onShowUnitSideDrawer = () => {
    dispatch({ type: SHOW_UNIT_SIDE_DRAWER, status: !showUnitSideDrawer });
  };

  return (
    <div className="drawer">
      <div className="design-main-new">
        <LoadOnConvertUnit
          show={silentRebuildLoading}
          updateList={silentRebuildList}
        />
        <BackDropLoading
          loading={parentLoading || loading || limeLoading}
          designMode={progress}
        />
        <Grid container className="actionBar">
          <Grid item className="unit-manager">
            <MuiIconButton
              title={<Translator id="unitList" />}
              icon={<Icons.ListUl />}
              onClick={onShowUnitSideDrawer}
              hidden={size > 992 ? true : false}
              className="secondary-button-filled"
            />
            <NewUnit
              disabled={loading}
              backToSave={backToSave}
              onEnterDialog={() => {
                setNewUnitAction(true);
              }}
              onExitDialog={(status) => {
                setOpenNewUnitAllow(false);
                !status && setNewUnitAction(false);
              }}
              onClick={addNewUnit}
              setShow={openNewUnitAllow}
              designSetting={newUnitSettingData}
              setDesignSetting={setNewUnitSettingData}
            />
            {/* <MuiButton
              title={t('_zakhire')}
              innerIcon={<Icons.CloudArrowUp />}
              onClick={onSave}
              className="success design-save-button"
              disabled={!unitInfo || loading}
            /> */}
          </Grid>
          <Grid item className="unit-manager">
            {breakFrame && !loading && <SelectBreakFrame />}
            <MuiIconButton
              title={<Translator id="_zakhire" />}
              icon={<Icons.Floppy />}
              onClick={onSave}
              disabled={!unitInfo || loading}
              className="save-button"
            />
            {convertType?.slidingCount > 1 && convertType?.rail && (
              <MuiIconButton
                icon={<Icons.ArrowRepeat />}
                title={t("SlidingToHinge")}
                onClick={() => onConvertType("sliding")}
                className="primary-button"
              />
            )}
            {convertType?.is_change && !convertType?.rail && (
              <MuiIconButton
                icon={<Icons.ArrowRepeat />}
                title={t("HingedToSliding")}
                onClick={() => onConvertType("pop")}
                className="primary-button"
              />
            )}
            {unitInfo && [1, 2, 5, 6].includes(unitInfo["Sys_tak_joft"]) && (
              <MuiIconButton
                title={<Translator id="equalGlass" />}
                icon={<FlipOutlined />}
                onClick={onEqualGlass}
                className="primary-button"
              />
            )}
            <MuiIconButton
              title={showEye ? t("disableGuideLines") : t("enableGuideLines")}
              icon={showEye ? <Icons.Eye /> : <Icons.EyeSlash />}
              onClick={onClickEye}
              disabled={!unitInfo}
              className="primary-button"
            />
            <MuiIconButton
              title={<Translator id="fitScreen" />}
              icon={<Icons.ArrowsFullscreen />}
              onClick={onFitScreen}
              disabled={!unitInfo}
              className="primary-button"
            />
          </Grid>
        </Grid>
        {selectedUnitINfo && (
          <div className="unitInfoData">
            <span>{`[${selectedUnitINfo?.Name}] [${t("count")}:${
              selectedUnitINfo.CountUnit
            }] ${
              selectedUnitINfo?.Location !== ""
                ? "[" + selectedUnitINfo?.Location + "]"
                : ""
            }`}</span>
          </div>
        )}
        {/* <div className="designZoom p-1">
          <div onClick={handleZoomIn} className="btn btn-outline-success ml-1 px-1 py-1"><Icons.ZoomIn size={14}/></div>
          <div onClick={handleZoomOut} className="btn btn-outline-danger ml-1 px-1 py-1"><Icons.ZoomOut size={14}/></div>
          <div onClick={handleZoomReset} className="btn btn-outline-warning px-1 py-1"><Icons.ArrowCounterclockwise size={14}/></div>
        </div> */}
        {/* <div className="new-unit-manager">
          <div className={`plus-icon ${addNewOpen ? 'close' : ''}`} onClick={() => {setAddNewOpen(!addNewOpen)}}>
            <Icons.Plus />
          </div>
          {addNewOpen && (
            <NewUnit
              disabled={loading}
              backToSave={backToSave}
              onEnterDialog={() => {
                setNewUnitAction(true);
              }}
              onExitDialog={(status) => {
                setOpenNewUnitAllow(false);
                !status && setNewUnitAction(false);
              }}
              onClick={addNewUnit}
              setShow={openNewUnitAllow}
              designSetting={newUnitSettingData}
              setDesignSetting={setNewUnitSettingData}
            />
          )}
          <MuiButton
            title={<Icons.CloudArrowUp size={18} />}
            onClick={onSave}
            className="success"
            disabled={!unitInfo || loading}
          />
        </div> */}
        <div id="openfl-content" />
        <EditUnit open={openDialog} handleDialog={handleDialog} />
        <RightClickDialog
          sendRightClickData={sendRightClickData}
          openDialog={openDialogRight}
          handleDialog={handleDialogRightClick}
          data={rightClickData}
        />
        <SelectTemplateDialog
          openDialog={openDialogSelectTemplate}
          handleDialog={handleDialogSelectTemplate}
          sendConvertData={sendConvertData}
          data={convertType}
        />
      </div>
    </div>
  );
}
